import { render } from "./NotificationTabs.vue?vue&type=template&id=f03ca8e8"
import script from "./NotificationTabs.vue?vue&type=script&lang=js"
export * from "./NotificationTabs.vue?vue&type=script&lang=js"
script.render = render

export default script